"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Newsletter;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Newsletter(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "newsletter"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M89,24.291H20.882a3.5,3.5,0,0,0-3.5,3.5v3.49H11.747A4.252,4.252,0,0,0,7.5,35.528V71.461a4.252,4.252,0,0,0,4.247,4.248h8.135a2.587,2.587,0,0,0,.5-.05,3.559,3.559,0,0,0,.5.05H89a3.5,3.5,0,0,0,3.5-3.5V27.791A3.5,3.5,0,0,0,89,24.291ZM12.5,36.281h4.882V70.709H12.5Zm75,34.428H22.382V29.291H87.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M59.364,37.554H83.72a1.5,1.5,0,0,0,0-3H59.364a1.5,1.5,0,0,0,0,3Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M59.364,51.5H83.72a1.5,1.5,0,0,0,0-3H59.364a1.5,1.5,0,0,0,0,3Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M59.364,65.446H83.72a1.5,1.5,0,0,0,0-3H59.364a1.5,1.5,0,0,0,0,3Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50.954,62.446H26.6a1.5,1.5,0,0,0,0,3H50.954a1.5,1.5,0,1,0,0-3Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.162,51.391h23.23a2.5,2.5,0,0,0,2.5-2.5V37.054a2.5,2.5,0,0,0-2.5-2.5H27.162a2.5,2.5,0,0,0-2.5,2.5V48.891A2.5,2.5,0,0,0,27.162,51.391Zm.5-13.837h22.23V48.391H27.662Z"
  })))));
}